import { Stack } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import CertificateCard from "../CertificateCard/CertificateCard";
import Template1 from "./Template1";
import Template2 from "./Template2";
import Template3 from "./Template3";
import Template4 from "./Template4";
import Template5 from "./Template5";
import Template6 from "./Template6";
import Template7 from "./Template7";
import Template8 from "./Template8";
import Template9 from "./Template9";
import Template10 from "./Template10";
import Template11 from "./Template11";
import Template12 from "./Template12";

const InsideTemplateSection = () => {
  const { state } = useLocation(); // Access passed state
  // const card = state || {}; // Fallback to an empty object if no state is passed
  const { card, index } = state || {}; // Access the passed card and index

  // console.log("card_details:--------->>>", card);

  return (
    <>
      <Header />
      <main style={{ marginBottom: "80px" }}>
        <Template1 card={{ card }} index={index} />
        <Template2 card={{ card }} index={index} />
        <Template3 card={{ card }} index={index} />
        <Template4 card={{ card }} index={index} />
        <Template5 card={{ card }} index={index} />
        <Template6 card={{ card }} index={index} />
        <Template7 card={{ card }} index={index} />
        <Template8 card={{ card }} index={index} />
        <Template9 card={{ card }} index={index} />
        <Template10 card={{ card }} index={index} />
        <Template11 card={{ card }} index={index} />
        <Template12 card={{ card }} index={index} />
      </main>
      <CertificateCard />
      <Footer />
    </>
  );
};

export default InsideTemplateSection;
